export type Capability = {
  id: string;
  label: string;
  icon: string;
  hint: string;
  skillIds: string[];
  playbookIds: string[];
};

export const CAPABILITIES: Capability[] = [
  {
    id: 'database',
    label: 'Database',
    icon: 'ri-database-2-line',
    hint: 'Persistent storage',
    skillIds: ['mongo-database'],
    playbookIds: [],
  },
  {
    id: 'domain',
    label: 'Custom Domain',
    icon: 'ri-global-line',
    hint: 'Your own URL',
    skillIds: ['aws-terraform'],
    playbookIds: [],
  },
  {
    id: 'auth',
    label: 'Authentication',
    icon: 'ri-shield-keyhole-line',
    hint: 'Users & login',
    skillIds: ['app-auth-google'],
    playbookIds: [],
  },
  {
    id: 'theme',
    label: 'Color scheme',
    icon: 'ri-palette-line',
    hint: 'Brand theming',
    skillIds: ['frontend-layout', 'react-tailwind-frontend'],
    playbookIds: [],
  },
  {
    id: 'kb',
    label: 'Knowledge Base',
    icon: 'ri-book-2-line',
    hint: 'Docs & guides',
    skillIds: [],
    playbookIds: [],
  },
  {
    id: 'research',
    label: 'Research Agents',
    icon: 'ri-search-eye-line',
    hint: 'AI research',
    skillIds: ['deep-research'],
    playbookIds: ['deep-research-brief'],
  },
  {
    id: 'admin',
    label: 'Admin Panel',
    icon: 'ri-dashboard-3-line',
    hint: 'Manage data',
    skillIds: [],
    playbookIds: [],
  },
  {
    id: 'stripe',
    label: 'Stripe',
    icon: 'ri-bank-card-line',
    hint: 'Payments',
    skillIds: ['app-stripe-billing'],
    playbookIds: [],
  },
];

export function mapCatalogIdToCapability(id: string): string | null {
  const needle = id.trim();
  if (!needle) return null;
  for (const cap of CAPABILITIES) {
    if (cap.skillIds.includes(needle) || cap.playbookIds.includes(needle)) return cap.id;
  }
  return null;
}

export function foldCatalogIds(ids: string[]): string[] {
  const out: string[] = [];
  for (const id of ids) {
    const cap = mapCatalogIdToCapability(id);
    if (cap && !out.includes(cap)) out.push(cap);
  }
  return out;
}

export function capabilityLabels(ids: string[]): string[] {
  return ids
    .map((id) => CAPABILITIES.find((c) => c.id === id)?.label)
    .filter((label): label is string => Boolean(label));
}
